module.exports = __webpack_public_path__ + "img/album03_04.b1f032a9.jpg";